var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import MPSessionStorage from "@/services/MPSessionStorage";
import { Mixpanel } from "./Mixpanel";
export var MixpanelEvents = {
    wabaOnboardingStarted: function (props) {
        var name = "waba_onboarding_started";
        var displayName = "WABA onboarding started";
        var description = "User has entered any of the starting points for the WABA onboarding";
        Mixpanel.track({
            name: name,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    userLoggedInEvent: function (props) {
        var name = "user_logged_in";
        var displayName = "User Logged In";
        var description = "User has successfully logged in";
        Mixpanel.track({ name: name, displayName: displayName, description: description, props: __assign({}, props) });
    },
    userLoggedOutEvent: function (props) {
        var eventName = "user_logged_out";
        var displayName = "User Logged Out";
        var description = "User has successfully logged out";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    accountCreatedEvent: function (props) {
        var eventName = "client_account_created";
        var displayName = "Client Account Created";
        var description = "when signup is successful and user/client is created. applies also for self-hosted ES, where partner creates client via API";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    submitCompanyDetailsEvent: function (props) {
        var name = "submit_company_details";
        var displayName = "Submit Company Details";
        var description = "User has submitted company details form";
        Mixpanel.track({ name: name, displayName: displayName, description: description, props: __assign({}, props) });
    },
    submitPartnerBillingTerms: function (props) {
        var name = "billing_terms_chosen";
        var displayName = "Billing terms chosen";
        var description = "Partner has selected partner-paid or client-paid";
        Mixpanel.track({ name: name, displayName: displayName, description: description, props: __assign({}, props) });
    },
    requestedOTPEvent: function (props) {
        var eventName = "otp_requested";
        var displayName = "OTP requested";
        var description = "OTP has been requested by the user";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    OTPRequestFailed: function (props) {
        var eventName = "otp_request_failed";
        var displayName = "OTP failed";
        var description = "OTP request has failed";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    submitVatInfo: function (props) {
        var name = "submit_vat_information";
        var displayName = "Submit VAT Information";
        var description = "User has submitted VAT information form";
        Mixpanel.track({ name: name, displayName: displayName, description: description, props: __assign({}, props) });
    },
    errorVerifyingEmail: function (props) {
        var eventName = "email_verification_error";
        var displayName = "Error verifying email";
        var description = "Error occurred during email verification";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    statusOfNumberToOnboard: function (props) {
        var eventName = "status_of_number_to_onboard";
        var displayName = "Initial Status of the Number to Onboard Provided";
        var description = "when user provides the number status";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    wabaPlanSelected: function (props) {
        var eventName = "WABA_plan_selected";
        var displayName = "WABA Plan Selected";
        var description = "when user selects the plan and continues to the next screen";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    wabaPurchaseAuthorized: function (props) {
        var eventName = "payment_authorized";
        var displayName = "WABA Purchase Authorized";
        var description = "greenlight given by billing system. By calling payment/check";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    esStarted: function (props) {
        var eventName = "embedded_signup_started";
        var displayName = "Embedded Signup started";
        var description = "when user presses the “start embedded signup” button on FE";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    esFinished: function (props) {
        var eventName = "embedded_signup_finished";
        var displayName = "ES Finished";
        var description = "when user comes back from Meta embedded signup window to FE";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    esFinishedCallback: function (props) {
        var eventName = "embedded_signup_finished_callback";
        var displayName = "ES Finished with Callback message";
        var description = "When event listener receives message from closed Meta embedded signup window";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    fbCallbackFinished: function (props) {
        var eventName = "fb_callback_finished";
        var displayName = "FB Callback Finished";
        var description = "When fb_login_callback is finished successfully";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    esSessionInfoListenerError: function (props) {
        var eventName = "error_during_callback";
        var displayName = "Error during callback";
        var description = "When embedded signup event listener receives callback with error";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    fbCallbackError: function (props) {
        var eventName = "error_during_fb_callback";
        var displayName = "Error during FB callback";
        var description = "When fb_login_callback fails";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    esCallbackError: function (props) {
        var eventName = "error_during_es_callback";
        var displayName = "Error during ES callback";
        var description = "Error during embedded signup launch";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    esCancelled: function (props) {
        var eventName = "user_cancelled_es";
        var displayName = "User cancelled ES";
        var description = "When the user closes the ES window";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    fbCallbackRequest: function (props) {
        var eventName = "es_fb_callback_request_payload";
        var displayName = "ES FbCallback Request Payload";
        var description = "When the fb_login_callback request is sent";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    numberPermissionGranted: function (props) {
        var eventName = "number_permission_granted";
        var displayName = "Number permission granted";
        var description = "when user grants permissions to partner for number";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    numberPermissionGrantedError: function (props) {
        var eventName = "number_permission_granted_error";
        var displayName = "Number permission granted error";
        var description = "Error granting permissions to partner";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    numberSetupStarted: function (props) {
        var eventName = "number_setup_start";
        var displayName = "Number Setup Started";
        var description = "when FE calls fb login callback on BE and call is successful";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    apiKeyCreated: function (props) {
        var eventName = "API_key_created";
        var displayName = "API KEY Created";
        var description = "When a user created the api key for the number";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    submitPaymentDetailsEvent: function (props) {
        var eventName = "partner_payment_method_added";
        var displayName = "Partner Payment Method Added";
        var description = "Partner has added a payment method";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    submitClientPaymentDetailsEvent: function (props) {
        var eventName = "client_payment_method_added";
        var displayName = "Client Payment Method Added";
        var description = "Client has added a payment method";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    numberConnected: function (props) {
        var eventName = "number_connected";
        var displayName = "Number Successfully Connected";
        var description = "when registration and callbacker url set is done. hub.integration.state=running";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    numberSetupFailed: function (props) {
        var eventName = "number_connection_failed";
        var displayName = "Number Setup Failed";
        var description = "when registration callbacker is done and hub.integration.state=failed";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    numberSetupFailedNotMapped: function (props) {
        var eventName = "es_callback_not_mapped_error";
        var displayName = "ES Callback Not Mapped Error";
        var description = "when registration callback is done and the callback url is not mapped to any error in FE";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    numberSetupRegistrationFailed: function (props) {
        var eventName = "number_registration_failed";
        var displayName = "Number Registration Failed";
        var description = "when registration callback is done and hub.integration.state=registration_failed";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    tableColumnReordered: function (props) {
        var eventName = "table_column_reordered";
        var displayName = "Table Column Reordered";
        var description = "Reorder any of the columns within a table";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
        console.log("".concat(eventName), props);
    },
    tableColumnDisplayChanged: function (props) {
        var eventName = "table_column_display_changed";
        var displayName = "Table Column Display Changed";
        var description = "When a column is hidden or shown in a table view";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
        console.log("".concat(eventName), props);
    },
    tableFieldFiltered: function (props) {
        var eventName = "table_field_filtered";
        var displayName = "Table Field Filtered";
        var description = "Table field has been filtered";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
        console.log("".concat(eventName), props);
    },
    tableFieldSorted: function (props) {
        var eventName = "table_field_sorted";
        var displayName = "Table Field Sorted";
        var description = "Table field has been sorted";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
        console.log("".concat(eventName), props);
    },
    tableExported: function (props) {
        var eventName = "table_exported";
        var displayName = "Table Exported";
        var description = "Table data has been exported";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    errorEvent: function (eventName, props) {
        var displayName = eventName;
        var name = eventName.replace(/ /g, "_").toLowerCase();
        Mixpanel.track({
            name: name,
            displayName: displayName,
            props: __assign(__assign({}, props), { type: "event" })
        });
    },
    partnerPlanCancelled: function (props) {
        var eventName = "partner_plan_cancelled";
        var displayName = "Partner Plan Cancelled";
        var description = "A partner user has cancelled the partner plan";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    partnerPlanUpdated: function (props) {
        var eventName = "partner_plan_updated";
        var displayName = "Partner Plan Updated";
        var description = "A partner user has updated the partner plan subscription";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    partnerPlanRevoked: function (props) {
        var eventName = "partner_plan_cancel_revoked";
        var displayName = "Partner Plan Cancel Revoked";
        var description = "A partner user has revoked the partner plan cancelation";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    setBillingAndWabaCurrency: function (props) {
        var eventName = "set_billing_waba_currency";
        var displayName = "Set Billing & Waba Currency";
        var description = "A partner user defines the billing & waba currency for the partner";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    selectPartnerPlan: function (props) {
        var eventName = "select_partner_plan";
        var displayName = "Select Partner Plan";
        var description = "A partner user selects a partner plan";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign(__assign({}, props), { new_plan: props.plan })
        });
    },
    setPartnerBillingAddress: function (props) {
        var eventName = "set_partner_billing_address";
        var displayName = "Set Partner Billing Address";
        var description = "A partner user defines the partner billing address";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    validateVATID: function (props) {
        var eventName = "set_and_validate_vat_id";
        var displayName = "Set and Validate VAT ID";
        var description = "A partner user validates the VAT ID";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    setPublicProfileName: function (props) {
        var eventName = "set_public_profile_name";
        var displayName = "Set Public Profile Name";
        var description = "A partner user defines the public profile partner name";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    setPublicProfileLogo: function (props) {
        var eventName = "set_public_profile_logo";
        var displayName = "Set Public Profile Logo";
        var description = "A partner user defines the public profile partner logo";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    setPartnerWebhookURL: function (props) {
        var eventName = "set_partner_webhook_url";
        var displayName = "Set Partner Webhook URL";
        var description = "A partner user defines the partner webhook URL";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    setPartnerRedirectURL: function (props) {
        var eventName = "set_partner_redirect_url";
        var displayName = "Set Partner Redirect URL";
        var description = "A partner user defines the partner redirect URL";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    copyIOLink: function (props) {
        var eventName = "copy_io_link";
        var displayName = "Copy IO Link";
        var description = "A partner user copies the Integrated Onboarding link to clipboard";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    copyIOButtonCode: function (props) {
        var eventName = "copy_io_button_code";
        var displayName = "Copy IO Button Code";
        var description = "A partner user copies the Integrated Onboarding button code snippet to clipboard";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    channelAddedAndVerified: function (props) {
        var eventName = "channel_added_and_verified";
        var displayName = "Channel Added and Verified";
        var description = "Partner was able to add a channel via the IO link successfully";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    generateNumberApiKey: function (props) {
        var eventName = "generate_number_api_key";
        var displayName = "Generate Number API Key";
        var description = "A partner user generates the API Key for a specific number";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    setNumberWebhookURL: function (props) {
        var eventName = "set_number_webhook_url";
        var displayName = "Set Number Webhook URL";
        var description = "A partner user defines the webhook URL for a specific number";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    openWaMeLink: function (props) {
        var eventName = "open_wame_link";
        var displayName = "Open Wa.Me Link";
        var description = "A partner user copies the wa.me link for a specific number";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    sendFirstMessageCurlCopied: function (props) {
        var eventName = "send_first_message_curl_copied";
        var displayName = "Send First Message Curl Copied";
        var description = "A partner user copies Curl to enable the first message to a specific number";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    bookActivationCall: function (props) {
        var eventName = "onboarding_help_requested";
        var displayName = "Onboarding help requested";
        var description = "A partner user clicked book an activation call button";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    sandboxVerificationStarted: function (props) {
        var name = "sandbox_verification_started";
        var displayName = "Sandbox Verification Started";
        var description = "User initiated number verification in the sandbox.";
        Mixpanel.track({
            name: name,
            displayName: displayName,
            description: description,
            props: props
        });
    },
    sandboxVerificationCompleted: function (props) {
        var name = "sandbox_verification_completed";
        var displayName = "Sandbox Verification Completed";
        var description = "Number verification in the sandbox was successful.";
        Mixpanel.track({
            name: name,
            displayName: displayName,
            description: description,
            props: props
        });
    },
    sandboxMessageSent: function (props) {
        var name = "sandbox_message_sent";
        var displayName = "Sandbox Message Sent";
        var description = "A user sent a message via the sandbox.";
        Mixpanel.track({
            name: name,
            displayName: displayName,
            description: description,
            props: props
        });
    },
    sandboxWebhookUpdated: function (props) {
        var name = "sandbox_webhook_updated";
        var displayName = "Sandbox Webhook Updated";
        var description = "The webhook URL in the sandbox was edited.";
        Mixpanel.track({
            name: name,
            displayName: displayName,
            description: description,
            props: props
        });
    },
    sandboxTryButton: function (props) {
        var name = "sandbox_try_button_clicked";
        var displayName = "Sandbox Try Button Clicked";
        var description = "The button on the Partner Onboarding Partner Plan page for Sandbox redirect.";
        Mixpanel.track({
            name: name,
            displayName: displayName,
            description: description,
            props: props
        });
    },
    partnerOnboardingStarted: function (props) {
        var _a;
        var eventName = "partner_onboarding_started";
        var displayName = "Partner Onboarding Started";
        var description = "A partner user has reached the first activation step of the partner onboarding flow for the first time";
        var flow = (_a = MPSessionStorage.get(MPSessionStorage.keys.QUALIFICATION_FLOW)) === null || _a === void 0 ? void 0 : _a.toUpperCase();
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({ qualification: flow }, props)
        });
        MPSessionStorage.remove(MPSessionStorage.keys.QUALIFICATION_FLOW);
    },
    partnerOnboardingAccessed: function (props) {
        var eventName = "partner_onboarding_accessed";
        var displayName = "Partner Onboarding Accessed";
        var description = "A partner user has re-entered the partner onboarding flow after it was already started";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    createPartnerClientAccount: function (props) {
        var eventName = "create_partner_client_account";
        var displayName = "Create Partner Client Account";
        var description = "A partner user creates a client account via API";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    triggerIOFromPartnerOnboarding: function (props) {
        var eventName = "trigger_io_from_partner_onboarding";
        var displayName = "Trigger IO from Partner Onboarding";
        var description = "A partner triggers the IO from the partner onboarding 'Register number' step";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    partnerOnboardingCompleted: function (props) {
        var eventName = "partner_onboarding_completed";
        var displayName = "Partner Onboarding Completed";
        var description = "A partner user has worked through every required step of the partner onboarding flow. Reported on the status transition, not on a verified test message: the final substep's Continue button has no delivery check.";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    partnerOnboardingTechProviderViewDocsClicked: function (props) {
        var eventName = "partner_onboarding_visit_tech_provider_docs";
        var displayName = "Partner Onboarding Visit Tech Provider Docs";
        var description = "A partner user has visited the tech provider documentation during onboarding";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    partnerAssistedOnboardingSelected: function (props) {
        var eventName = "partner_assisted_onboarding_selected";
        var displayName = "Partner Assisted Onboarding Selected";
        var description = "A partner user has selected assisted onboarding";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    partnerOnboardingSelfOnboardingSelected: function (props) {
        var eventName = "partner_self_onboarding_selected";
        var displayName = "Partner Self Onboarding Selected";
        var description = "A partner user has selected self onboarding";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    partnerOnboardingCalendarLinkClicked: function (props) {
        var eventName = "partner_onboarding_calendar_link_clicked";
        var displayName = "Partner Onboarding Calendar Link Clicked";
        var description = "A partner user has clicked the calendar link during onboarding";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    partnerOnboardingWhatsAppLinkClicked: function (props) {
        var eventName = "partner_onboarding_whatsapp_link_clicked";
        var displayName = "Partner Onboarding WhatsApp Link Clicked";
        var description = "A partner user has clicked the WhatsApp link during onboarding";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    initialIOQueryParams: function (props) {
        var eventName = "initial_io_query_params";
        var displayName = "Initial IO Query Params";
        var description = "Initial IO query parameters received";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    mmLiteAcceptedTOS: function (props) {
        var eventName = "mmlite_accepted_tos";
        var displayName = "MMLite Accepted TOS";
        var description = "MMLite Accepted Terms of Service";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    mmLiteTosViewed: function (props) {
        var eventName = "mmlite_tos_viewed";
        var displayName = "MMLite TOS Viewed";
        var description = "MMLite Terms of Service Viewed";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    triggerMMliteToS: function (props) {
        var eventName = "trigger_mmlite_tos";
        var displayName = "Trigger MMLite ToS";
        var description = "A partner triggers the MMLite Terms of Service";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    esCallbackReceived: function (props) {
        var eventName = "embedded_signup_callback_received";
        var displayName = "Embedded Signup Callback Received";
        var description = "When event listener receives message from Meta embedded signup window";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    submitPartnerVatData: function (props) {
        var eventName = "submit_partner_vat_data";
        var displayName = "Submit Partner VAT Data";
        var description = "Partner has submitted VAT data form";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    partnerAccessDenied: function (props) {
        var eventName = "partner_access_denied";
        var displayName = "Partner Access Denied";
        var description = "User attempted to access a partner they don't have access to";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    errorSubmittingDataToHubSpot: function (props) {
        var eventName = "error_submitting_data_to_hubspot";
        var displayName = "Error Submitting Data to HubSpot";
        var description = "An error occurred while submitting data to HubSpot";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign({}, props)
        });
    },
    waPricingBannerViewed: function (props) {
        var eventName = "wa_pricing_banner_viewed";
        var displayName = "WhatsApp Pricing Banner Viewed";
        var description = "When the WhatsApp pricing announcement banner is shown to the user";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign(__assign({}, props), { hub: "partner_hub" })
        });
    },
    waPricingBannerCtaClicked: function (props) {
        var eventName = "wa_pricing_banner_cta_clicked";
        var displayName = "WhatsApp Pricing Banner CTA Clicked";
        var description = "When user clicks the rate cards link in the WhatsApp pricing banner";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign(__assign({}, props), { hub: "partner_hub" })
        });
    },
    waPricingBannerDismissed: function (props) {
        var eventName = "wa_pricing_banner_dismissed";
        var displayName = "WhatsApp Pricing Banner Dismissed";
        var description = "When user dismisses the WhatsApp pricing announcement banner";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign(__assign({}, props), { hub: "partner_hub" })
        });
    },
    newHubVisitClicked: function (props) {
        var eventName = "new_hub_visit_clicked";
        var displayName = "New Hub Visit Clicked";
        var description = "When user clicks the CTA to visit the new app from the redirect banner";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign(__assign({}, props), { hub: "partner_hub" })
        });
    },
    // Awaited by the caller before a full-page redirect, hence sendImmediately.
    partnerHubForceRedirectedToV2: function (props) {
        var eventName = "partner_hub_v2_force_redirect";
        var displayName = "Partner Hub V2 Force Redirect";
        var description = "Partner user on hub v1 was force-redirected to hub v2 by the partner_redirect_v1_to_v2 gate; fallback_to_root=true means the v1 route had no v2 equivalent and landed on the partner root";
        return Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign(__assign({}, props), { hub: "partner_hub", fallback_to_root: props.mappingKind === "fallback" }),
            options: { sendImmediately: true }
        });
    },
    partnerHubForceRedirectSkipped: function (props) {
        var eventName = "partner_hub_v2_force_redirect_skipped";
        var displayName = "Partner Hub V2 Force Redirect Skipped";
        var description = "Gate was on (or still undetermined) for a partner user but the redirect was not performed; reason says why";
        Mixpanel.track({
            name: eventName,
            displayName: displayName,
            description: description,
            props: __assign(__assign({}, props), { hub: "partner_hub" })
        });
    }
};
//# sourceMappingURL=data:application/json;base64,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